import { Component, effect, inject } from '@angular/core';
import { MifidChecksStatus } from '../rfq-setup/rfq-setup';
import { RfqMessagesService } from '@approot/rfq-messages/rfq-messages.service';
import { RfqSetupService } from '../rfq-setup/rfq-setup.service';
import { isEqual } from 'lodash';

type MifidCheckResponse = {
  content: {
    messageType: string;
    Compliance: boolean;
    'MiFID response': string;
    URL: string;
  };
};
@Component({
  selector: 'app-mifid-checks',
  templateUrl: './mifid-checks.component.html',
  styleUrls: ['./mifid-checks.component.scss']
})
export class MifidChecksComponent {
  public status: MifidChecksStatus;
  public msg: MifidCheckResponse;
  private rfqMessageService = inject(RfqMessagesService);
  private rfqSetupService = inject(RfqSetupService);
  constructor() {
    effect(
      _ => {
        const message = this.rfqMessageService.message();
        const mifid = message.mifidCheckResponse as MifidCheckResponse;
        if (mifid && !isEqual(mifid, this.msg)) {
          this.msg = mifid;
          if (mifid.content.Compliance != null) {
            this.rfqSetupService.mifidChecksStatus.set(
              mifid.content.Compliance ? 'GoodToTrade' : 'ChecksFailed'
            );
          }
        }
      },
      { allowSignalWrites: true }
    );
    effect(_ => {
      this.status = this.rfqSetupService.mifidChecksStatus();
      if (this.status == null || this.status === 'ChecksInProgress') {
        this.msg = null;
      }
    });
  }
}
